// groupConfig.js
export const GROUP_CONFIG = {
    ECMAnalytics: {
        label: "ECM",
        showCount: false
    },
    MedicationDispense: {
        label: "Medication",
        showCount: false,
        group: "Medication"
    },
    MedicationRequest: {
        label: "Medication",
        showCount: false,
        group: "Medication"
    },
    DiabetesGraph: {
        label: "Diabetes",
        showCount: false
    },
    DischargeSummary: {
        label: "Discharge Summary",
        showCount: false
    },
    ChronicConditions: {
        label: "Chronic Conditions",
        showCount: false
    },
    Patient: {
        label: "AI Patient Summary",
        showCount: false
    },
    "Observation - Other": {
        label: "Observation",
        showCount: true
    },
    "Observation - Depression": {
        label: "Depression",
        showCount: true
    },
    AllergyIntolerance: {
        label: "Allergy",
        showCount: true
    },
    DiagnosticReport: {
        label: "Diagnostic Report",
        showCount: true
    },
    ServiceRequest: {
        label: "Service Request",
        showCount: true
    },
    DocumentReference: {
        label: "Document Reference",
        showCount: false
    },
};
